import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PriceCurrencyPipe } from '@/common/pipes/price-currency.pipe';
import { PriceFormatPipe } from '@/common/pipes/price-format.pipe';
import { DriversSalaryV2StateService } from '../_services/drivers-salary-v2.state.service';
import { PRACA_FALLBACK_RATE } from '../_models/drivers-salary-v2.model';

@Component({
	selector: 'app-salary-external-systems',
	standalone: true,
	imports: [
		CommonModule,
		RouterLink,
		MatButtonModule,
		MatCardModule,
		MatExpansionModule,
		MatFormFieldModule,
		MatIconModule,
		MatInputModule,
		MatListModule,
		MatProgressSpinnerModule,
		MatTooltipModule,
		PriceCurrencyPipe,
		PriceFormatPipe,
	],
	templateUrl: './salary-external-systems.component.html',
	styleUrl: './salary-shared.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SalaryExternalSystemsComponent {
	readonly state = inject(DriversSalaryV2StateService);
	readonly pracaFallbackRateGrosze = PRACA_FALLBACK_RATE;
}
